import { useEffect } from 'react';
import { OnboardingState } from './useOnboardingState';

interface OnboardingEventsProps {
  saveOnboardingState: (newState: Partial<OnboardingState>) => void;
  refreshCounts?: () => void;
}

export const useOnboardingEvents = ({ saveOnboardingState, refreshCounts }: OnboardingEventsProps) => {
  
  useEffect(() => {
    const handleProductCreated = (event: any) => {
      saveOnboardingState({ hasCreatedProduct: true });
      setTimeout(() => {
        refreshCounts && refreshCounts();
      }, 100);
    };

    const handleOfferCreated = (event: any) => {
      console.log('Offer created event received, updating onboarding status', event);
      saveOnboardingState({ hasCreatedBundle: true });
      refreshCounts && refreshCounts();
    };

    const handleCopyLinkSuccess = (event: any) => {
      if (event.detail?.type === 'offer' || event.detail?.type === 'bundle') {
        saveOnboardingState({ 
          hasSharedLink: true, 
          showCompletionConfirmation: true 
        });
      }
    };

    globalThis.addEventListener('product-created', handleProductCreated);
    globalThis.addEventListener('offer-created', handleOfferCreated);
    globalThis.addEventListener('copy-link-success', handleCopyLinkSuccess);

    return () => {
      globalThis.removeEventListener('product-created', handleProductCreated);
      globalThis.removeEventListener('offer-created', handleOfferCreated);
      globalThis.removeEventListener('copy-link-success', handleCopyLinkSuccess);
    };
  }, [saveOnboardingState, refreshCounts]);
};
